<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'transfer-by-serial' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('stockTransfer.transferBySerial') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockTransfer.transferBySerial'),
            href: '/admin/transfer-by-serials'
          },
          {
            text: $t('stockTransfer.showDetail'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="waiting">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('stockTransfer.transfer_info') }}
                    </legend>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.transfer') }}
                        :
                      </div>
                      <div class="col-md-3">{{ edit_data.transfer_no }}</div>
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.date') }}
                        :
                      </div>
                      <div class="col-md-3">{{ edit_data.transfer_date }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.from_branch') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.from_branch
                            ? edit_data.from_branch.branch_name_en
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.to_branch') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.to_branch
                            ? edit_data.to_branch.branch_name_en
                            : ''
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.from_location') }} :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.from_location
                            ? edit_data.from_location.location_name_en
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.to_location') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.to_location
                            ? edit_data.to_location.location_name_en
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.transfered_by') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.transferred_by
                            ? edit_data.transferred_by.employee
                              ? edit_data.transferred_by.employee
                                  .employee_name_en
                              : ''
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.received_by') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.received_by
                            ? edit_data.received_by.employee
                              ? edit_data.received_by.employee.employee_name_en
                              : ''
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('stockTransfer.status') }} :
                      </div>
                      <div class="col-md-3">
                        <span
                          :class="statusStyle(edit_data.transfer_status_id)"
                          >{{
                            status(edit_data.transfer_status_id) +
                            (edit_data.transfer_status_id == 1
                              ? edit_data.current_app_level
                                ? ' Lv:' + edit_data.current_app_level
                                : ''
                              : '')
                          }}</span
                        >
                      </div>
                      <!-- <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.total_amount') }}
                      :
                    </div>
                    <div class="col-md-3">
                      $ {{ format_number(edit_data.total_amount) }}
                    </div> -->
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('stockTransfer.transfer_details') }}
                    </legend>
                    <div class="overflow-auto max-h">
                      <ts-table :columns="columns" :records="datasource">
                        <template v-slot="{ record }">
                          <td class="text-nowrap">
                            {{ record.product ? record.product.barcode : '' }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.pro_group_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product.product_name_kh
                                ? record.product.product_name_kh
                                : record.product.product_name_en
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.product_grade }}
                          </td>
                          <!-- <td class="text-center text-nowrap">
                            $ {{ format_number(record.cost) }}
                          </td> -->
                          <td class="text-center text-nowrap">
                            {{ record.quantity }}
                          </td>
                          <!-- <td class="text-center text-nowrap">
                            $
                            {{ format_number(record.cost * record.quantity) }}
                          </td> -->
                          <td class="text-center text-nowrap">
                            <a
                              href="#"
                              v-if="
                                record.stock_transfer_detail_serial.length > 0
                              "
                              v-tooltip="$t('stockTransfer.serial')"
                              class="text-info"
                              @click.prevent="serial(record)"
                            >
                              <i class="fas fa-align-justify"></i>
                            </a>
                          </td>
                        </template>
                      </ts-table>
                    </div>
                    <div class="ts-mt-1 ts-text-right ts-font-bold text-danger">
                      TOTAL : {{ total }}
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="ts-flex ts-justify-end">
            <span v-if="edit_data.transfer_status_id == 1">
              <ts-button
                v-if="transfer_type === 'received'"
                @click.prevent="reject(edit_data)"
                color="warning"
              >
                <i class="far fa-times-circle"></i> {{ $t('reject') }}
              </ts-button>
              <ts-button
                v-if="transfer_type === 'received'"
                @click.prevent="confirm"
                color="success"
                class="ml-2"
              >
                <i class="far fa-check-circle"></i> {{ $t('confirm') }}
              </ts-button>
            </span>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal
      v-if="show_modal_confirm"
      v-model="show_modal_confirm"
      :title="$t('stockTransfer.are_you_sure_to_confirm')"
      :centered="true"
      :maskClosable="false"
      :okText="$t('confirm')"
      :zIndex="1020"
      :confirmLoading="confirming"
      width="300px"
      @ok="onConfirm"
      @cancel="onCanel"
    >
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('stockTransfer.confirmDate')
              }}</label>
              <div>
                <a-date-picker
                  class="ts-w-full"
                  :allowClear="false"
                  v-model="received_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  :disabled-date="disabledDate"
                />
                <div class="validate" v-if="errors.has('received_date')">
                  {{ errors.first('received_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ShowSerials from './components/show-serial'
import RejectReason from './components/reason-reject.vue'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })

export default {
  name: 'previewDetail',
  data () {
    return {
      waiting: false,
      confirming: false,
      show_serial: false,
      show_modal_confirm: false,
      status_id: 1,
      datasource: [],
      received_date: null,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('stock/transferBySerial', ['edit_data']),
    total () {
      return _.sumBy(this.datasource, function (el) {
        return el.quantity
      })
    },
    columns () {
      return [
        { name: this.$t('stockTransfer.barcode') },
        { name: this.$t('stockTransfer.group') },
        { name: this.$t('stockTransfer.product') },
        { name: this.$t('stockTransfer.grade'), style: 'text-align:center' },
        { name: this.$t('stockTransfer.qty'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px' }
      ]
    },
    transfer_type: {
      get () {
        return this.$store.state.stock.transferBySerial.transfer_type
      },
      set (val) {
        this.$store.commit('stock/transferBySerial/SET_TRANSFER_TYPE', val)
      }
    },
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case 1:
          badge = 'badge badge-info'
          break
        case 2:
          badge = 'badge badge-primary'
          break
        case 3:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    status: () => status => {
      let value = ''

      switch (status) {
        case 1:
          value = 'Pending'
          break
        case 2:
          value = 'Received'
          break
        case 3:
          value = 'Rejected'
          break
      }

      return value
    }
  },
  created () {
    this.setDetails()
  },
  methods: {
    disabledDate (received_date) {
      // Can not select days before transfer_date
      return (
        received_date < moment(this.edit_data.transfer_date, 'DD-MM-YYYY') ||
        received_date >= moment()
      )
    },
    setDetails () {
      this.datasource = this.edit_data.stock_transfer_details
    },
    format_number (value) {
      return parseFloat(value).toFixed(2)
    },
    serial (item) {
      this.$modal.show(
        ShowSerials,
        {
          data: item
        },
        {
          height: 'auto',
          width: '600px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    confirm () {
      this.show_modal_confirm = true
    },
    reject (record) {
      this.$modal.show(
        RejectReason,
        {
          record: record
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    async checkReceiveMonthDiffMonthTransfer (data) {
      try {
        let response = await this.$store.dispatch(
          'stock/transferBySerial/checkReceiveMonthDiffMonthTransfer',
          data
        )
        if (response) {
          this.confirming = false
          if (
            await this.$confirmModal.danger(
              '<span class="text-primary">Month of confirm date and transfer date are different.</span><br /><br />' +
                'Transfer Date: <span class="text-success ts-font-bold">' +
                this.edit_data.transfer_date +
                '</span><br />Confirm Date: <span class="text-success ts-font-bold">' +
                this.received_date +
                '<br /> <br /> <span class="ts-font-bold text-warning">Are you sure to confirm?</span>'
            )
          ) {
            return true
          } else {
            return false
          }
        }
        return true
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.confirming = false
      }
    },
    async onConfirm () {
      this.errors = new Errors()
      this.confirming = true
      if (
        await this.checkReceiveMonthDiffMonthTransfer({
          stock_transfer_id: this.edit_data.stock_transfer_id,
          transfer_status_id: 2,
          received_date: this.received_date,
          transfer_date: this.edit_data.transfer_date
        })
      ) {
        this.confirming = true
        this.$store
          .dispatch('stock/transferBySerial/confirm', {
            stock_transfer_id: this.edit_data.stock_transfer_id,
            transfer_status_id: 2,
            received_date: this.received_date
          })
          .then(response => {
            this.confirming = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'transfer-by-serial' })
          })
          .catch(error => {
            if (
              error.message ===
                'The current user not yet belong to any warehouses.' ||
              error.message ===
                'Transferred and received user must be defferent.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            this.errors = new Errors(error.errors)
            this.confirming = false
          })
      }
    },
    onCanel () {
      this.show_modal_confirm = false
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>
